(function($, undefined) {
	'use strict';
	var utils;
	
	var init = function() {
		utils = Fw.component.models().utils;
		const table = $('#buttons-table');
		const childrenTable = $('.buttons-children-table');

		table.sortable({
			items: '> .table__tbody.draggable',
			handle: '.drag',
			cancel: '',
			cursor: 'grabbing',
			placeholder: "highlight",
			helper: "clone",
			forceFallback: true,
            start: function (event, ui) {
                ui.item.addClass("highlight");
            },
            stop: function (event, ui) {
                ui.item.removeClass("highlight");
                
                updateParentButtonPositions($(ui.item));
            }
		});

		childrenTable.sortable({
			handle: '.drag',
			cancel: '',
			cursor: 'grabbing',
			placeholder: "highlight",
			forceFallback: true,
			start: function (event, ui) {
				ui.item.addClass("highlight");
			},
			stop: function (event, ui) {
				ui.item.removeClass("highlight");
				
				updateChildrenButtonPositions($(ui.item));
			}
		});
	};
	
	var updateParentButtonPositions = function($currentParent) {
		console.log($currentParent);
		var container = $('#buttons-table');
		var allParents = $('> .table__tbody', container);
		
		var ajaxCount = allParents.length;
		
		$('.site-overlay').addClass('site-overlay_processing');
		allParents.each((i, el) => {
			const fields = ["field14", "field13"];
			const values = [i, "true"];
			utils.updateGenDataFields($(el).attr('data-id'), fields, values, () => {
				ajaxCount--;
				if (ajaxCount === 0) {
					_complete();
				}
			});
		});
		
		var _complete = function() {
			$('.site-overlay').removeClass('site-overlay_processing');	
		};
	};
	
	var updateChildrenButtonPositions = function($currentChild) {
		console.log($currentChild);
		var container = $('#buttons-table');
		var parent = $currentChild.closest('.table__tbody');
		var dragParent = parent.closest('.draggable');
		
		var allChildren = $('.table__tr', parent);
		var ajaxCount = allChildren.length;
		
		$('.site-overlay').addClass('site-overlay_processing');
		allChildren.each((i, el) => {
			const fields = ["field14", "field13", "field8"];
			const values = [i, "true", dragParent.attr('data-id')];
			utils.updateGenDataFields($(el).attr('data-id'), fields, values, () => {
				ajaxCount--;
				if (ajaxCount === 0) {
					_complete(parent);
				}
			});
		});
		
		var _complete = function(parent) {
			$('.site-overlay').removeClass('site-overlay_processing');
			updateChildrenUI(parent);
		};
	};
	
	var updateChildrenUI = function(parent) {
		$('.table__tr', parent).each((i, el) => {
			$('.table__tr-counter', el).text(i + 1);
		});
	};

	$(window).ready(function() {
		init();
	});
})(jQuery);
